import {ErrorMessageConstants} from '../shared/error-message-constants';

export class Error {
  code: string;
  message: string;

  private CAFE_PENDING_ORDER_ERROR = 'pending order';
  private CAFE_REACH_CHECKED_ORDER_ERROR = 'OCAPI-ERR-4123';

  constructor(code: string, message: string) {
    this.code = code;
    this.message = message;
    return this;
  }

  public isWaitingActivation(): boolean {
    return this.code === ErrorMessageConstants.OCAPI_ERR_ODSO123;
  }

  public isOrderPending(): boolean {
    return this.message.toLowerCase().indexOf(this.CAFE_PENDING_ORDER_ERROR) !== -1;
  }

  public isReachCheckFailed() {
    return this.code.indexOf(this.CAFE_REACH_CHECKED_ORDER_ERROR) !== -1 ;
  }
}
